module.exports = __webpack_public_path__ + "img/jianhao_2afc53d16.png";